<template>
  <!--<transition v-if="showDescription && message !== ''" name="slowZoom" mode="out-in" appear>
    <div class="messageGuide">
        <span style="font-size: 5em; font-weight: bold">
          {{message}}
        </span>
    </div>
  </transition>-->
  <div class="gridBlocks">
    <h1 class="titlecream"><slot name="title"></slot></h1>
    <div class="settingsCardInside">
        <slot name="message"></slot>
        <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "settingsCard",

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
  props:{
    message:{default:''},
  },
  mounted() {
    window.setTimeout(() => {
      this.showDescription = false
    }, 2000);
  },
  data() {
    return {
      showDescription: true,
    }
  }
}
</script>

<style scoped>
.messageGuide{
  width: 80%;
}

.gridBlocks {
  display: grid;
  grid-template-rows: 3vw calc(100% - 3vw);
  background-color: hsl(0, 50%, 95%);
  border: 0.2vw var(--goalBackgroundColor2) solid;
  height: fit-content;
  max-height: calc(100% - 0.4vw);
  min-height: 80%;
  width: fit-content;
  max-width: calc(100% - 0.4vw);
  min-width: min(70%, 50vw);
  border-radius: 1.5vw;
  transition: all 0.5s;
}

.titlecream {
  color: hsl(0, 50%, 95%);
  background-color: var(--goalBackgroundColor2);
  padding: 0.2vw 1vw 0.4vw 1vw;
  border-radius: 1.5vw 0 1.5vw 0;
  width: fit-content;
  height: fit-content;
  font-size: 1.7em;
  margin-top: -0.2vw;
  margin-left: -0.2vw;
}

.settingsCardInside{
  position: relative;
  overflow: visible;
}

.slowZoom-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0.5;
  font-size: 4em;

}

.slowZoom-enter-active {
  transition: all 2s;
  -webkit-transition: all 2s;
  -ms-transition: all 2s;
}

@media screen and (max-device-width: 767px) {
  .gridBlocks {
    border-width: 0;
    border-radius: 0;
    background-color: transparent;
    grid-template-rows: 20vw calc(100% - 20vw);
    max-width: 100%;
    max-height: 100%;
    min-height: 100%;
    min-width: 100%;
  }

  .titlecream {

    border-radius: 0 20vw 20vw 0;
    padding: 2vw 3vw 1vw 2vw;
    margin: 0 4vw 0 0;
    font-size: 1.5em;
    align-self: center;
  }


  .settingsCardInside{
    padding: 0;
    width: 100%;
    max-width: 100%;
    overflow: auto;
  }
}
</style>